import * as firebase from 'firebase';

const firebaseConfig = {
  apiKey: "AIzaSyAJB0DcT-1F9hkLvC7eu_H4I66PpU-wM1g",
  authDomain: "inititles-cdc16.firebaseapp.com",
  databaseURL: "https://inititles-cdc16.firebaseio.com",
  projectId: "inititles-cdc16",
  storageBucket: "inititles-cdc16.appspot.com",
  messagingSenderId: "276044298243",
  appId: "1:276044298243:web:259b3dfb687553fe"
};

firebase.initializeApp(firebaseConfig);

export default firebase;